// target process actions
export const SET_TARGET_PROCESS = 'SET_TARGET_PROCESS';
export const SET_FETCHED_DISTRIBUTION_LIST = 'SET_FETCHED_DISTRIBUTION_LIST';
export const SET_FETCHED_GROUP = 'SET_FETCHED_GROUP';
export const SET_FETCHED_GROUP_PANEL_SEGMENT = 'SET_FETCHED_GROUP_PANEL_SEGMENT';
export const SET_FETCHED_EPISODE = 'SET_FETCHED_EPISODE';
export const SET_FETCHED_PANEL = 'SET_FETCHED_PANEL';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_USER_LOCATION = 'SET_CURRENT_USER_LOCATION';
export const SET_PANEL_PARTNER = 'SET_PANEL_PARTNER';

export const SET_ACTIVITY_LIST = 'SET_ACTIVITY_LIST';
export const SET_MY_LIST = 'SET_MY_LIST';
export const INVALIDATE_ACTIVITY_LIST = 'INVALIDATE_ACTIVITY_LIST';
export const INVALIDATE_MY_LIST = 'INVALIDATE_MY_LIST';
export const ADD_STUDY_TO_MY_LIST = 'ADD_STUDY_TO_MY_LIST';

export const SET_USER_DISCLAIMER = 'SET_USER_DISCLAIMER';
export const SET_USER_MONITOR = 'SET_USER_MONITOR';

export const SET_PILOTLY_POINTS = 'SET_PILOTLY_POINTS';

export const SET_WAITING_FOR_PERMISSION = 'SET_WAITING_FOR_PERMISSION';
export const SET_NAVIGATOR_AUDIO_PERMISSIONS = 'SET_NAVIGATOR_AUDIO_PERMISSIONS';

export const SET_TECH_CHECK_CONNECTION_RESULT = 'SET_TECH_CHECK_CONNECTION_RESULT';
export const SET_TECH_CHECK_CONNECTION_SPEED_RESULT = 'SET_TECH_CHECK_CONNECTION_SPEED_RESULT';
export const SET_TECH_CHECK_SPEAKER_TEST_ANSWER = 'SET_TECH_CHECK_SPEAKER_TEST_ANSWER';
export const SET_TECH_CHECK_PLAYBACK_TEST_ANSWER = 'SET_TECH_CHECK_PLAYBACK_TEST_ANSWER';
export const SET_TECH_CHECK_FINISHED_STATUS = 'SET_TECH_CHECK_FINISHED_STATUS';

// GoogleAnalyticsReducer
export const STORE_GLOBAL_ANALYTICS_ADAPTER = "STORE_GLOBAL_ANALYTICS_ADAPTER";
export const STORE_GA_TRACKER = "STORE_GA_TRACKER";



// WEBPACK FOOTER //
// ./src/redux/actions/constants.js